import React, { useEffect } from "react";
import "./Subscribe.css";
// import { TiSocialGooglePlus } from "react-icons/ti";
import { FaFacebookF, FaTwitter, FaInstagram ,FaLinkedin} from "react-icons/fa";


import AOS from "aos";
import "aos/dist/aos.css";

const Subscribe = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);
  return (
    <section id="subscribe">
      <div className="container subscribe" data-aos="fade-up">
        <h1>Envia correo a:</h1>
        <h2>help@jsbackup.com</h2>
        {/* <form>
          <div className="form-control">
            <input type="text" placeholder="Enter Your Email..." />
            <button>Subscribe</button>
          </div>
        </form> */}
        <div className="social-icons">
          <div className="social-icon">
            <a href="https://www.linkedin.com/company/jsbackup" >
             <FaLinkedin/>
            </a>
          </div> 
          <div className="social-icon">
          <a href="https://www.facebook.com/JSBACKUPs" >
            <FaFacebookF />
          </a>  
          </div>
          <div className="social-icon">
            <a href="https://x.com/jsbackup" >
            
            <FaTwitter />
            </a>
          </div>
          <div className="social-icon">
            <a href="https://www.instagram.com/jsbackupgt/" >
            <FaInstagram />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Subscribe;
